import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Home from '@/pages/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { skipAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== from.path && to.name !== 'home') {
    store.commit('loading/SET_PAGE_LOADING', true)
  }
  next()
})

router.afterEach((to) => {
  if (to.name === 'home') return
  window.setTimeout(() => {
    store.commit('loading/SET_PAGE_LOADING', false)
  }, 280)
})

export default router
